import React from "react";
import { Tabs, TabContent } from "react-bootstrap";
import StudentUpload from "./StudentUpload";
import StudentManagement from "./StudentManagement";
import { STUDENT_DATA_CONSTANTS } from "../../config/constants";
import { StudentDataStyled } from "./styled";
import { CustomBreadcrumb } from "../../components";

const StudentData = () => {
  return (
    <StudentDataStyled>
      <CustomBreadcrumb
        header={STUDENT_DATA_CONSTANTS.HEADER}
        currentPage={STUDENT_DATA_CONSTANTS.HEADER}
        isCreateUser={false}
      >
        <div className="student-page-header pt-0 pb-4">
          <Tabs
            unmountOnExit
            defaultActiveKey="upload"
            id="uncontrolled-tab-example"
          >
            <TabContent
              eventKey="upload"
              title={STUDENT_DATA_CONSTANTS.STUDENT_DATA_UPLOAD}
            >
              <StudentUpload />
            </TabContent>

            <TabContent
              eventKey="profile"
              title={STUDENT_DATA_CONSTANTS.STUDENT_MANAGEMENT}
              mountOnEnter={true}
            >
              <StudentManagement />
            </TabContent>
          </Tabs>
        </div>
      </CustomBreadcrumb>
    </StudentDataStyled>
  );
};

export default StudentData;
